import React from 'react'
import { Box, Grid } from '@mui/material'
import { PropertyOverview } from 'components/property/shared/PropertyOverview'
import {
    flattenAndMapHouseUnits,
    getAllOwners,
    getMainProperty,
    getMainPropertyCadastreNumber,
} from 'utils/cadastre-utils'
import { CartProperty, PropertyResponse } from 'components/search/models/property-search-response'
import { PropertyProductsList } from 'components/property/products/PropertyProductsList'
import { useTranslation } from 'react-i18next'
import { GeneralPropertyUnitTable } from 'components/property/shared/GeneralPropertyUnitTable'

type Props = {
    land: PropertyResponse
}

export const LeasedPropertyRootView: React.FC<Props> = ({ land }) => {
    const { t } = useTranslation()

    const mainProperty = getMainProperty(land.properties) || land.properties[0]
    const sanitizedMainPropertyCadastreNr = getMainPropertyCadastreNumber(mainProperty?.cadastreNumber || null)
    const owners = getAllOwners([mainProperty])
    const allHouseUnits = flattenAndMapHouseUnits([mainProperty])

    const property: CartProperty = {
        cadastreNumber: sanitizedMainPropertyCadastreNr,
        postalCode: mainProperty?.housingUnits[0]?.address.postalCode,
    }

    return (
        <>
            <Grid item xs={12}>
                <PropertyOverview
                    data={[mainProperty]}
                    isPropertySectioned={false}
                    sanitizedMainPropertyCadastreNr={sanitizedMainPropertyCadastreNr}
                    mainProperty={mainProperty}
                    allOwners={owners}
                />
                <div>
                    <Box mt={2}>
                        <PropertyProductsList property={property} />
                    </Box>
                    <Box mt={2}>
                        <GeneralPropertyUnitTable
                            units={allHouseUnits}
                            title={t('HOUSING_UNITS', 'Bruksenheter ({{huCount}})', {
                                huCount: allHouseUnits.length,
                            })}
                        />
                    </Box>
                </div>
            </Grid>
            <Grid item xs={12}></Grid>
        </>
    )
}
